import themeOptions from './themeOptions';

const luzmoStyles = {
  loaderBackground: 'transparent',
  loaderFontColor: themeOptions.palette.text.primary,
  loaderSpinnerBackground: 'transparent',
  loaderSpinnerColor: (themeOptions.palette.primary as { main: string }).main,
  mainColor: (themeOptions.palette.primary as { main: string }).main,
};

export default luzmoStyles;
